import React, { useState } from 'react';
import { Destination } from '../../../data/destinationData';
import GoogleMapComponent from '../../GoogleMapComponent';

interface OverviewProps {
  destination: Destination;
}

const DestinationOverview: React.FC<OverviewProps> = ({ destination }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const latitude = destination.latitude;
  const longitude = destination.longitude;

  const renderOverview = () => {
    const maxIndex = isExpanded ? destination.overViewHd.length : 3;
    return destination.overViewHd.slice(0, maxIndex).map((header, index) => (
      <div key={index}>
        <h3 className='cont-head'>{header}</h3>
        <p>{destination.overView[index]}</p>
        <br />
      </div>
    ));
  };

  return (
    <>
    <div className='flex flex-wrap'>
      <div className='w-full md:w-3/4 md:pr-12'>
            <div>
              {renderOverview()}
              {isExpanded && (
                <>
                  <h3 className='cont-head'>Things to do</h3>
                  <p>{destination.thingsToDo}</p>
                </>
              )}
            </div>
            <button
              onClick={toggleExpand}
              className="mt-4 text-halo-pink font-medium hover:text-red-700 focus:outline-none"
            >
              {isExpanded ? 'Read Less' : 'Read More'}
            </button>
      </div>

        <div className='w-full md:w-1/4'>
        {destination.fastFacts.length == 0 ? '' :
          <p className='flex items-start'>
            <svg className='stroke-current text-halo-pink mr-2 -mt-2' xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" viewBox="0 0 32 32">
                <path xmlns="http://www.w3.org/2000/svg" d="M29 2.18c-.52-.43-1.2-.64-1.86-.6-1.3.03-2.55.6-3.45 1.53l-5.75 5.8-11.82-.76h-.1a2.07 2.07 0 00-1.32.49l-2.03 1.8c-.27.32-.43.73-.44 1.15.07.4.37.75.77.88l8.32 3.07-3.45 3.6h-.6c-1.04 0-2.68-.05-3.28-.05h-.22c-.22 0-.6-.1-1.7.82l-.1.05a1.51 1.51 0 00-.39.88c-.01.32.14.62.38.82.16.16 2.63 1.7 4.65 2.96l2.85 4.54c.16.27.45.44.77.44h.06a1.7 1.7 0 00.99-.49c.93-1.04.77-1.48.77-1.7v-4.05l3.6-3.45 3 8.27a.95.95 0 00.88.71h.1c.4-.02.76-.17 1.04-.44l1.75-2.03c.4-.4.6-.93.55-1.48 0-.16-.55-8.5-.7-11.72l5.8-5.8c2.02-2.03 1.7-4.5.93-5.26zm-2.2 4l-5.8 5.8-.55.6.06.77.44 7.12.27 4.6c0 .1 0 .1-.1.27-.27.33-.7.88-1.15 1.3-.6-1.75-1.97-5.37-2.68-7.34l-.93-2.63-1.97 1.97-3.6 3.45-.44.55-.06.66v3.83c.06.06.06.16.1.22 0-.06-.1-.06-.1-.06v-.16c-.07-.05-.1-.13-.1-.22-.77-1.15-1.75-2.74-2.08-3.23l-.22-.38-.33-.22c-1.26-.77-2.74-1.64-3.6-2.24H3.9l-.06-.06c.03.03.07.05.1.06h1.3c.66.06 1.48.06 2.03.06h.6l.7-.06.5-.5 3.45-3.56 1.97-1.92-2.57-1-7.4-2.74c.44-.44 1-.88 1.26-1.15.12-.05.18-.1.23-.1h.06c.22 0 2.63.16 4.93.33l6.84.44.77.06.6-.55 5.75-5.8a2.99 2.99 0 012.19-1.04c.2-.02.42.02.6.1.16.32.33 1.52-.94 2.73z" fill="#6db4a9"></path>
            </svg>
            {destination.fastFacts[4]}
          </p>
        }
        </div>
    </div>
    <div className='mt-8'>
        <h2>Map of {destination.name}</h2>
        <div className="map-outer mt-4">
            <div className="map-canvas md:w-[70%] !h-80 overflow-hidden bg-gray-100">
          <GoogleMapComponent
            apiKey="AIzaSyD3BQK4fqJwhNVoFZyk6EB1whUD-3NehqI"
            latitude={parseFloat(latitude)}
            longitude={parseFloat(longitude)}
            zoom={7}
          />
            </div> 
        </div>
    </div>
    </>
  );
};

export default DestinationOverview;
